/* global APP, JitsiMeetJS, config, interfaceConfig */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getModeratorTabProps } from '../../settings/functions.any';
import Switch from '../../base/ui/components/web/Switch';
import { useDispatch, useSelector } from 'react-redux';
import { sendCommand } from '../../mod-command/slice';
import { COMMANDS } from '../../mod-command/constants';
const GeneralSettings = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { startAudioMuted, startVideoMuted, followMeEnabled, followMeActive, disableReactionsModeration, startReactionsMuted } = useSelector((state) => getModeratorTabProps(state));
    const [startAudioMutedState, setStartAudioMutedState] = useState(false);
    const [startVideoMutedState, setStartVideoMutedState] = useState(false);
    const [startReactionsMutedState, setStartReactionsMutedState] = useState(false);
    useEffect(() => {
        setStartAudioMutedState(startAudioMuted);
    }, [startAudioMuted]);
    useEffect(() => {
        setStartVideoMutedState(startVideoMuted);
    }, [startVideoMuted]);
    useEffect(() => {
        setStartReactionsMutedState(startReactionsMuted);
    }, [startReactionsMuted]);
    const handleChangeStartAudioMuted = (event) => {
        const value = {
            startAudioMutedState: startAudioMutedState,
            startVideoMutedState: startVideoMutedState
        };
        dispatch(sendCommand(COMMANDS.HANDLE_CHANGE_START_AUDIO_MUTED.COMMANDS, JSON.stringify(value), true));
        // APP.store.dispatch(setStartMutedAudioPolicy(!startAudioMutedState, startVideoMutedState))
        setStartAudioMutedState(!startAudioMuted);
    };
    const handleChangeStartVideoMuted = (event) => {
        const value = {
            startAudioMutedState: startAudioMutedState,
            startVideoMutedState: startVideoMutedState
        };
        dispatch(sendCommand(COMMANDS.HANDLE_CHANGE_START_VIDEO_MUTED.COMMANDS, JSON.stringify(value), true));
        // APP.store.dispatch(setStartMutedVideoPolicy(!startVideoMutedState, startAudioMutedState))
        setStartVideoMutedState(!startVideoMutedState);
    };
    const handleChangeStartReactionsMuted = (event) => {
        dispatch(sendCommand(COMMANDS.HANDLE_CHANGE_START_REACTIONS_MUTED.COMMANDS, startReactionsMutedState, true));
        // APP.store.dispatch(setStartReactionsMuted(!startReactionsMutedState, true));
        // APP.store.dispatch(updateSettings({ soundsReactions: !!startReactionsMutedState }));
        setStartReactionsMutedState(!startReactionsMutedState);
    };
    return (React.createElement("div", { style: { marginTop: '12px' } },
        React.createElement("div", { className: 'controller-meeting-header controler-header' }, t('menuController.generalSettings')),
        React.createElement("div", { className: "controler-list-item" },
            React.createElement("div", null,
                React.createElement("div", { className: "controler-item controler-item-toogle item-checkbox", onClick: handleChangeStartAudioMuted },
                    React.createElement("span", null, t('menuController.startAudioMuted')),
                    React.createElement(Switch, { checked: startAudioMutedState, onChange: handleChangeStartAudioMuted })),
                React.createElement("div", { className: "controler-item controler-item-toogle item-checkbox", onClick: handleChangeStartVideoMuted },
                    React.createElement("span", null, t('menuController.startVideoMuted')),
                    React.createElement(Switch, { checked: startVideoMutedState, onChange: handleChangeStartVideoMuted })),
                !disableReactionsModeration &&
                    React.createElement("div", { className: "controler-item controler-item-toogle item-checkbox", onClick: handleChangeStartReactionsMuted },
                        React.createElement("span", null, t('menuController.startReactionsMuted')),
                        React.createElement(Switch, { checked: startReactionsMutedState, onChange: handleChangeStartReactionsMuted }))))));
};
export default GeneralSettings;
